<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->

<template>
  <div id="page-application-edit">
    <vs-alert color="danger" title="Application Not Found" :active.sync="not_found">
      <span>Application record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'application.list'}" class="text-inherit underline">All
        Applications</router-link>
      </span>
    </vs-alert>

    <vs-row v-if="data">
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-1">{{ data.ApplicationName }}</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <div class="vx-card p-4">
              <application-edit-details v-model="data_local" />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <vs-col>
            <div class="vx-card p-4">
              <application-uri-details v-model="data_local" />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <vs-col>
            <div class="vx-card p-4">
              <application-token-details
                  v-if="data_local.ExternalIdentity.jwt_configuration"
                  v-model="data_local" />
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button @click="cancel" class="my-4" >Cancel</vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button  @click="saveChanges"
                      color="light"
                      class="my-4">Save</vs-button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>


import ApplicationEditDetails from "@/views/pages/applications/edit/ApplicationEditDetails";
import ApplicationUriDetails from "@/views/pages/applications/edit/ApplicationUriDetails";
import ApplicationTokenDetails from "@/views/pages/applications/edit/ApplicationTokenDetails";
import ApplicationValidation from "@/validation/Application";
ApplicationValidation.init();

export default {
  components: {
    ApplicationEditDetails,
    ApplicationUriDetails,
    ApplicationTokenDetails
  },
  data () {
    return {
      data: null,
      not_found: false,
      data_local: null,
    }
  },
  computed: {
    isValid() {
      return this.data;
    },
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    async fetch(applicationId) {
      try {
        this.data = null;
        const { data } = await this.$api.applications.get(applicationId, { params: {'include' : 'roles'} });
        const application = data.data;

        if (!application.ExternalIdentity.allowed_origins) {
          application.ExternalIdentity.allowed_origins = [];
        }

        this.data = application;
        this.data_local = JSON.parse(JSON.stringify(application))
      } catch (e) {
        console.error(e)
      } finally {
        if (!this.data) {
          this.not_found = true
        }
      }
    },
    async saveChanges () {

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
      const params = {
        ...this.data_local,
      };

      delete params.applications;

      try {
        await this.$api.applications.update(this.id, params);
        this.$vs.notify({
          title: 'Application updated',
          iconPack: 'feather',
          color: 'success',
          position: 'top-right'
        })
        this.$router.push({ name: 'application.view', params: { id: this.id }}).catch(() => {});
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to update. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    cancel () {
      this.$router.push({name: 'application.view', params: { id: this.id }});
    },
  },

  created () {
    this.fetch(this.$route.params.id)
  }
}

</script>
